export default "__VITE_ASSET__e3$actXN__"